import client, { Response } from './client';
import { Server } from '../../types/menu';

export type MenuResponse = {
  menus: Server.Menu[];
  categories: Server.Category[];
  products: Server.Product[];
  modifier_groups: Server.ModifierGroup[];
  modifiers: Server.Modifier[];
};

export const loadMenu = (storeId: string): Response<MenuResponse> =>
  client.get(`/stores/${storeId}/menu`);
